import type { Theme } from './types';

export const highContrastTheme: Theme = {
  name: 'High Contrast',
  id: 'high-contrast',
  colours: {
    background: {
      primary: '#000000',
      secondary: '#0a0a0a',
      tertiary: '#111111',
      elevated: '#1a1a1a',
    },
    text: {
      primary: '#ffffff',
      secondary: '#e0e0e0',
      tertiary: '#b0b0b0',
      inverse: '#000000',
    },
    accent: {
      primary: '#00d9ff',
      secondary: '#bf5af2',
      success: '#30d158',
      warning: '#ff9f0a',
      error: '#ff453a',
    },
    feedback: {
      placed: '#30d158',
      misplaced: '#ff9f0a',
      incorrect: '#636366',
    },
    rarity: {
      common: '#ffffff',
      uncommon: '#30d158',
      rare: '#00d9ff',
      epic: '#bf5af2',
      legendary: '#ffcc00',
    },
    powerUp: {
      boost: '#ff9f0a',
      surge_i: '#ff453a',
      surge_ii: '#ff375f',
      oracle: '#bf5af2',
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  typography: {
    fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      xxl: '1.5rem',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: 1.25,
      normal: 1.5,
      relaxed: 1.75,
    },
  },
  borders: {
    radius: {
      sm: '0.125rem',
      md: '0.25rem',
      lg: '0.375rem',
      full: '9999px',
    },
    width: {
      thin: '2px',
      normal: '3px',
      thick: '4px',
    },
  },
  shadows: {
    sm: '0 0 0 1px rgba(255, 255, 255, 0.3)',
    md: '0 0 0 2px rgba(255, 255, 255, 0.4)',
    lg: '0 0 0 3px rgba(255, 255, 255, 0.5)',
    xl: '0 0 0 4px rgba(255, 255, 255, 0.6)',
    glow: '0 0 20px rgba(0, 217, 255, 0.5)',
  },
  transitions: {
    fast: '150ms ease-in-out',
    normal: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },
  scanlineAlpha: 0,
  vignetteEnabled: false,
  fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
  rarityColours: {
    common: '#ffffff',
    uncommon: '#30d158',
    rare: '#00d9ff',
    epic: '#bf5af2',
    legendary: '#ffcc00',
  },
  powerUpColours: {
    oracle: '#bf5af2',
    surge: '#ff453a',
    boost: '#ff9f0a',
  },
};
